import { Box, BoxProps, Text } from '@jfs/ui-new'
import { NavigationContainer, NavigationIndependentTree } from '@react-navigation/native'
import { createStackNavigator } from '@react-navigation/stack'
import { FC } from 'react'
import ErrorView from '../screens/ErrorView'
import { Review } from '../screens/Review'
import UPI from '../screens/Upi'
import Progress from '../screens/Upi/Progress'
import UpiInput from '../screens/Upi/UpiInput'
import { pages } from '../utils/constants'

const styles = {
  container: { flex: 1, display: 'flex' } as BoxProps,
}

const Stack = createStackNavigator()

const UpiStack: FC = (props: any) => {
  return (
    <Box {...styles.container}>
      <NavigationIndependentTree>
        <NavigationContainer
          ref={props.navigationRef}
          onReady={props.onReady}
          onStateChange={props.onStateChange}
          {...props}
          independent={true}
          fallback={<Text>Loading...</Text>}>
          <Stack.Navigator initialRouteName={pages.upi} screenOptions={{ headerShown: false }}>
            <Stack.Screen name={pages.upi} component={UPI} />
            <Stack.Screen name={pages.handle} component={UpiInput} />
            <Stack.Screen name={pages.review} component={Review} />
            <Stack.Screen name={pages.progress} component={Progress} />
            <Stack.Screen name={pages.ErrorView} component={ErrorView} options={{ headerShown: false }} />
          </Stack.Navigator>
        </NavigationContainer>
      </NavigationIndependentTree>
    </Box>
  )
}

export default UpiStack
